export const REGULAR_EXPRESSIONS = {
  NAME: /^[A-Za-z\s]+$/,
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
};
